import { GET_HURRICANE_BY_LATLON_PENDING
    , GET_HURRICANE_BY_LATLON_FULFILLED
    , GET_HURRICANE_BY_LATLON_REJECTED
    , GET_HURRICANE_LEGEND_PENDING
    , GET_HURRICANE_LEGEND_FULFILLED
    , GET_HURRICANE_LEGEND_REJECTED
    , SELECT_HURRICANE
    , SELECT_HURRICANE_TRACK_POINT
} from '../actions/hurricaneActions';
import { getPressureUnit, getDistanceUnit, getSpeedUnit, getWindDirection } from '../../utilities/apiConversionUtil';
import uniqBy from 'lodash.uniqby';
import { HurricaneUtil } from '../../utilities/hurricaneUtil';

const initialState = {
    hurricanesGeoJson: { features: [] },
    legend: {}
};

// Reducers specify how the application's state changes in response to actions sent to the store

function _selectHurricanePoint(geometry, properties) {
    if (!geometry?.coordinates?.length > 1 || !properties || !Object.keys(properties).length) {
        return {};
    }

    const coordinates = geometry.coordinates.slice();
    const lon = parseFloat(coordinates[0]).toFixed(1);
    const lat = parseFloat(coordinates[1]).toFixed(1);

    //We have to do null string checks because apparently mapbox-gl-js converts the nulls into string nulls so when
    //we get the data from mapbox like in a symbol layer press it comes back as 'null'.
    return {
        distance: convertNullStringToNull(properties.dis),
        distanceUnit: getDistanceUnit(properties.disu),
        wind: convertNullStringToNull(properties.w),
        windUnit: getSpeedUnit(properties.wu),
        gust: convertNullStringToNull(properties.g),
        gustUnit: getSpeedUnit(properties.gu),
        pressure: convertNullStringToNull(properties.p),
        pressureUnit: getPressureUnit(properties.pu),
        directionUnit: getDistanceUnit(properties.diru),
        coordinates: Math.abs(lat) + (lat > 0 ? '°N' : '°S') + ' ' + Math.abs(lon) + (lon > 0 ? '°E' : '°W'),
        direction: getWindDirection(convertNullStringToNull(properties.dir)),
        category: convertNullStringToNull(properties.cs) ? properties.cs : properties.tn,
        datetimeUtc: properties.dt,
        hurricaneType: convertNullStringToNull(properties.tn),
        speed: convertNullStringToNull(properties.s),
        speedUnit: getSpeedUnit(properties.su),
        pointType: properties.dtypes,
        t: properties.t,
        dtype: properties.dtype,
        categoryNumber: properties.c,
        basin: properties.bn
    };
}

function convertNullStringToNull(property) {
    return property === 'null' ? null : property;
}

export function hurricane(state = initialState, action)
{
    switch (action.type)
    {
        case GET_HURRICANE_BY_LATLON_PENDING:
        {
            return {
                ...state,
                hurricaneIsFetching: true,
                hurricanesGeoJson: initialState.hurricanesGeoJson
            };
        }
        case GET_HURRICANE_BY_LATLON_FULFILLED:
        {
            const hurricanesGeoJson = action.payload;
            const currentTrackPointGeoJson = HurricaneUtil.getCurrentTrackPoint(hurricanesGeoJson);
            const hurricanes = uniqBy(hurricanesGeoJson?.features?.filter(x => x.properties.n)?.map(x=> { return { id: x.properties.id, name: x.properties.n, type: x.properties.tn };}), 'id');
            const currentTrackPoint = _selectHurricanePoint(currentTrackPointGeoJson?.geometry, currentTrackPointGeoJson?.properties);
            const currentHurricane = hurricanes?.find(x => x.id === currentTrackPointGeoJson?.properties?.id);

            return {
                ...state,
                hurricanesGeoJson,
                lastError: {},
                hurricaneIsFetching: false,
                hurricanes,
                currentTrackPointGeoJson,
                currentTrackPoint,
                currentHurricaneIndex: 0,
                currentHurricane
            };
        }

        case GET_HURRICANE_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                hurricanesGeoJson: { features: [] },
                lastError: action.payload,
                hurricaneIsFetching: false
            };
        }

        case GET_HURRICANE_LEGEND_PENDING:
        {
            return {
                ...state,
                hurricaneLegendIsFetching: true
            };
        }
        case GET_HURRICANE_LEGEND_FULFILLED:
        {
            return {
                ...state,
                legend: action.payload,
                lastLegendError: {},
                hurricaneLegendIsFetching: false
            };
        }

        case GET_HURRICANE_LEGEND_REJECTED:
        {
            return {
                ...state,
                legend: {},
                lastLegendError: action.payload,
                hurricaneLegendIsFetching: false
            };
        }

        case SELECT_HURRICANE:
        {
            const newHurricaneId = action.payload;
            const { hurricanesGeoJson, hurricanes } = state;
            const currentTrackPointGeoJson = hurricanesGeoJson.features.find(x => x.properties.id === newHurricaneId);
            const currentTrackPoint = _selectHurricanePoint(currentTrackPointGeoJson.geometry, currentTrackPointGeoJson.properties);
            const currentHurricane = hurricanes.find(x => x.id === currentTrackPointGeoJson.properties.id);
            const currentHurricaneIndex = hurricanes.findIndex(x => x.id === currentTrackPointGeoJson.properties.id);
            return {
                ...state,
                currentTrackPointGeoJson,
                currentTrackPoint,
                currentHurricane,
                currentHurricaneIndex
            };
        }

        case SELECT_HURRICANE_TRACK_POINT:
        {
            const currentTrackPointGeoJson = action.payload;
            const currentTrackPoint = _selectHurricanePoint(currentTrackPointGeoJson.geometry, currentTrackPointGeoJson.properties);
            return {
                ...state,
                currentTrackPointGeoJson,
                currentTrackPoint
            };
        }
        default: {
            return state;
        }
    }
}
